module.exports = __webpack_public_path__ + "static/media/15UN-Habitat14.7ece5cc5.jpg";